














import EventCard from '@front-app/components/cards/EventCard.vue';
import { BannerLocation } from '@front-app/services/ActionApi/UserActionRequestModel';
import { EventV2 } from '@front-app/services/EventsApi/EventModel';
import { defineComponent, PropType } from '@vue/composition-api';

export default defineComponent({
	components: { EventCard },
	props: {
		groupId: {
			type: String,
			default: '',
		},
		events: {
			type: Array as PropType<EventV2[]>,
			required: true,
		},
		bannerLocation: {
			type: String as PropType<BannerLocation>,
			required: true,
		},
	},
	setup() {
		return {};
	},
});
